import React, { useEffect, useState, useRef } from "react";
import dhamaMovesInit from "./components/dhamaMoves/dhamaMovesInit";
import handleMustEat from "./components/mustEat/handleMustEat";
import handleDhamaMoves from "./components/dhamaMoves/handleDhamaMoves";
import handleSquareClickEatMore from "./components/eatMore/handleSquareClickEatMore";
import handleSquareClick from "./components/clickEvent/handleSquareClick";
import soundFile from "./assets/Lightweight.wav";
import smokeImage from "./assets/smoke.gif";
import ShowStatistics from "./renderComponents/ShowGameStatistics";
import DhamaSetting from "./renderComponents/DhamaSetting";
import "./App.scss";
var x = 1;
var pawnsInTouch = [];
var finalAllWays = [];
var pawnsToEat = [];
let previouspawnMustEat;

const matrixOfPawns = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
  [20, 21, 22, 23, 24, 25, 26, 27, 28, 29],
  [30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
  [40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
  [50, 51, 52, 53, 54, 55, 56, 57, 58, 59],
  [60, 61, 62, 63, 64, 65, 66, 67, 68, 69],
  [70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
  [80, 81, 82, 83, 84, 85, 86, 87, 88, 89],
  [90, 91, 92, 93, 94, 95, 96, 97, 98, 99],
];
const arr = [
  1, 3, 5, 7, 9, 10, 12, 14, 16, 18, 21, 23, 25, 27, 29, 30, 32, 34, 36, 38, 61,
  63, 65, 67, 69, 70, 72, 74, 76, 78, 81, 83, 85, 87, 89, 90, 92, 94, 96, 98,
];
let dhamaIndex = [];
export function token(previouspawn) {
  x = 2;
  previouspawnMustEat = previouspawn;
  return x;
}
// let pWillBeginFirst;
// let pWillBeginFirstBoolean = false;

const Board = () => {
  const [prevSquare, setPrevSquare] = useState(null);
  const squareRef = useRef([]);
  const squareRefPawns = useRef([]);
  const [boardData, setBoardData] = useState([]);
  const boardDataRef = useRef(boardData);
  const [playerTurn, setPlayerTurn] = useState(null);
  const [animationTriggered, setAnimationTriggered] = useState(false);
  const [language, setLanguage] = useState("en");
  const [pWillBeginFirst, setPWillBeginFirst] = useState(null);
  const [activeSound, setActiveSound] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const [isContainerVisibleMobile, setContainerVisibleMobile] = useState(false);
  const [chooseStartFirstVisible, setChooseStartFirstVisible] = useState(true);

  const whoWillBeginFirst = (playerFirst) => {
    setChooseStartFirstVisible(false);
    if (playerFirst === "p1") {
      setPWillBeginFirst(1);
    } else if (playerFirst === "p2") {
      setPWillBeginFirst(2);
    }
  };

  useEffect(() => {
    if (pWillBeginFirst) {
      function playAudio() {
        if (activeSound) {
          new Audio(soundFile).play();
        }
      }
      playAudio();
      // const centeredSpan = document.querySelector(".centered-span");
      // if (pWillBeginFirst) {
      //   centeredSpan.style.display = "none";
      // } else {
      //   centeredSpan.style.display = "block";
      // }
      setPlayerTurn(pWillBeginFirst);
      // Trigger the animation only if it hasn't been triggered before
      if (!animationTriggered) {
        setAnimationTriggered(true);
      }
      arr.forEach((index) => {
        const divElement = squareRef.current[index];
        if (divElement && pWillBeginFirst) {
          divElement.style.backgroundImage = `url(${smokeImage})`;
          divElement.style.backgroundSize = "cover";
          divElement.style.backgroundRepeat = "no-repeat";
          divElement.style.backgroundPosition = "center";
          setTimeout(() => {
            divElement.style.backgroundImage = "none";
          }, 1000);
        }
      });
    }
  }, [pWillBeginFirst]);

  let boardElements = [];
  const boardSquare = (i, j) => {
    if (i % 2 === 0 && j % 2 === 1) {
      return "board-square-even";
    } else if (i % 2 === 1 && j % 2 === 0) {
      return "board-square-even";
    } else {
      return "board-square-odd";
    }
  };

  for (let i = 0; i < 10; i++) {
    for (let j = 0; j < 10; j++) {
      const isWhite =
        // i === 4 ||
        // i === 5 ||
        (i % 2 === 0 && j % 2 === 0) || (i % 2 === 1 && j % 2 === 1);
      // !change the board here
      // const squareColor = isWhite ? 4 : i < 5 ? 1 : i > 7 ? 2 : 0;
      // const className =
      //   squareColor === 1 || (squareColor === 2 && i < 5)
      //     ? "red-square"
      //     : squareColor === 1 || (squareColor === 2 && i > 7)
      //     ? "blue-square"
      //     : "";
      // !change the board here
      // const squareColor = isWhite ? 4 : i < 2 ? 1 : i > 4 ? 2 : 0;
      // const className =
      //   squareColor === 1 || (squareColor === 2 && i < 2)
      //     ? "red-square"
      //     : squareColor === 1 || (squareColor === 2 && i > 4)
      //     ? "blue-square"
      //     : "";
      // !change the board here
      // const squareColor = isWhite ? 4 : i < 1 ? 1 : i > 4 ? 2 : 0;
      // const className =
      //   squareColor === 1 || (squareColor === 2 && i < 1)
      //     ? "red-square"
      //     : squareColor === 1 || (squareColor === 2 && i > 4)
      //     ? "blue-square"
      //     : "";
      // !change the board here

      const squareColor = isWhite ? 4 : i < 4 ? 1 : i > 5 ? 2 : 0;
      const className =
        squareColor === 1 || (squareColor === 2 && i < 6)
          ? "red-square"
          : squareColor === 1 || (squareColor === 2 && i > 5)
          ? "blue-square"
          : "";

      const squareData = [squareColor, i, j];
      boardData.push(squareData);

      const squareElement = (
        <div className="board-square-wraper" key={`${i}-${j}`}>
          <div
            className={boardSquare(i, j)}
            onClick={() =>
              onClickhandler(
                boardDataRef,
                i,
                j,
                squareRef,
                squareRefPawns,
                boardData,
                setBoardData,
                playerTurn,
                prevSquare,
                setPrevSquare,
                setPlayerTurn,
                activeSound
              )
            }
            ref={(element) => (squareRef.current[i * 10 + j] = element)}
          ></div>

          <div
            ref={(element) => (squareRefPawns.current[i * 10 + j] = element)}
            className={`${className} ${animationTriggered ? "animate" : ""}`}
            onClick={() =>
              onClickhandler(
                boardDataRef,
                i,
                j,
                squareRef,
                squareRefPawns,
                boardData,
                setBoardData,
                playerTurn,
                prevSquare,
                setPrevSquare,
                setPlayerTurn,
                activeSound
              )
            }
          ></div>
        </div>
      );
      boardElements.push(squareElement);
    }
  }

  return (
    <div className="board-wrapper">
      <div className="setting-left">
        <DhamaSetting
          settingProp={playerTurn}
          language={language}
          setLanguage={setLanguage}
          activeSound={activeSound}
          setActiveSound={setActiveSound}
          isContainerVisibleMobile={isContainerVisibleMobile}
          setContainerVisibleMobile={setContainerVisibleMobile}
        />
      </div>

      <div className="board">{boardElements}</div>
      <div className="setting-right">
        <ShowStatistics
          settingProp={playerTurn}
          boardData={boardData}
          language={language}
          activeSound={activeSound}
          isVisible={isVisible}
          setIsVisible={setIsVisible}
        />
      </div>
      {chooseStartFirstVisible && (
        <div className="centered-span-container">
          <span className="centered-span">
            <div
              className="red-square"
              onClick={() => whoWillBeginFirst("p1")}
            ></div>
            <div
              className="blue-square"
              onClick={() => whoWillBeginFirst("p2")}
            ></div>
            <div>
              {language === "ar"
                ? "اختر من سيبدأ أولاً ؟"
                : "Choose who will start first?"}
            </div>
          </span>
        </div>
      )}
    </div>
  );
};

function onClickhandler(
  boardDataRef,
  i,
  j,
  squareRef,
  squareRefPawns,
  boardData,
  setBoardData,
  playerTurn,
  prevSquare,
  setPrevSquare,
  setPlayerTurn,
  activeSound
) {
  const clickedSquareData = boardData.find(
    (square) => square[1] === i && square[2] === j
  );
  const [squareColor, row, col] = clickedSquareData;
  if (prevSquare !== null) {
    const [prevRow, prevCol] = prevSquare;
    var prevSquareIndex = prevRow * 10 + prevCol;
  }
  const currentSquareIndex = row * 10 + col;
  // update dhamaIndexes array
  for (let i = 0; i < dhamaIndex.length; i++) {
    if (
      boardData[dhamaIndex[i][1]][0] === 31 ||
      boardData[dhamaIndex[i][1]][0] === 32
    ) {
    } else {
      dhamaIndex.splice(i, 1);
      i--; // Decrement i to account for the removed element
    }
  }
  if (pawnsInTouch.length !== 0 && x !== 2) {
    for (let i = 0; i < pawnsInTouch.length; i++) {
      if (
        (boardData[pawnsInTouch[i][0]][0] === 1 &&
          boardData[pawnsInTouch[i][1]][0] === 1 &&
          (boardData[pawnsInTouch[i][2]][0] === 2 ||
            boardData[pawnsInTouch[i][2]][0] === 32)) ||
        (boardData[pawnsInTouch[i][0]][0] === 2 &&
          boardData[pawnsInTouch[i][1]][0] === 2 &&
          (boardData[pawnsInTouch[i][2]][0] === 1 ||
            boardData[pawnsInTouch[i][2]][0] === 31)) ||
        (boardData[pawnsInTouch[i][0]][0] === 2 &&
          (boardData[pawnsInTouch[i][1]][0] === 1 ||
            boardData[pawnsInTouch[i][1]][0] === 31)) ||
        (boardData[pawnsInTouch[i][0]][0] === 1 &&
          (boardData[pawnsInTouch[i][1]][0] === 2 ||
            boardData[pawnsInTouch[i][1]][0] === 32))
      ) {
      } else {
        squareRef.current[pawnsInTouch[i][0]].classList.remove("gray-box");
        pawnsInTouch = pawnsInTouch.filter(
          (subArr) => !subArr.includes(pawnsInTouch[i][0])
        );
      }
    }
    if (pawnsInTouch.length !== 0) {
      var countMustForP1 = 0;
      var countMustForP2 = 0;
      var tempPrevousPawnP1;
      var tempPrevousPawnP2;

      var mustEat = false;
      for (let i = 0; i < pawnsInTouch.length; i++) {
        const minValue = Math.min(pawnsInTouch[i][0], pawnsInTouch[i][1]);
        const maxValue = Math.max(pawnsInTouch[i][0], pawnsInTouch[i][1]);
        if (pawnsInTouch[i].length === 3) {
          if (pawnsInTouch[i][0] < pawnsInTouch[i][2]) {
            if (pawnsInTouch[i][2] + 9 <= 98 && pawnsInTouch[i][2] + 11 <= 98) {
              if (
                playerTurn === 1 &&
                boardData[pawnsInTouch[i][2] + 9][0] === 0 &&
                boardData[pawnsInTouch[i][2] + 11][0] === 0
              ) {
                countMustForP1 += 1;
                mustEat = true;
                squareRef.current[pawnsInTouch[i][0]].classList.add(
                  "box-waiting-for-selection"
                );
                squareRef.current[pawnsInTouch[i][1]].classList.add(
                  "box-waiting-for-selection"
                );
              } else if (playerTurn === 1) {
                if (pawnsInTouch[i][2] + 9 <= 98) {
                  if (boardData[pawnsInTouch[i][2] + 9][0] === 0) {
                    countMustForP1 += 1;
                    tempPrevousPawnP1 = maxValue;
                    mustEat = true;
                    squareRef.current[maxValue].classList.add(
                      "box-waiting-for-selection"
                    );
                  }
                }
                if (pawnsInTouch[i][2] + 11 <= 98) {
                  if (boardData[pawnsInTouch[i][2] + 11][0] === 0) {
                    countMustForP1 += 1;
                    tempPrevousPawnP1 = minValue;
                    mustEat = true;
                    squareRef.current[minValue].classList.add(
                      "box-waiting-for-selection"
                    );
                  }
                }
              }
            }
          } else {
            if (pawnsInTouch[i][2] - 9 >= 1 && pawnsInTouch[i][2] - 11 >= 1) {
              if (
                playerTurn === 2 &&
                boardData[pawnsInTouch[i][2] - 9][0] === 0 &&
                boardData[pawnsInTouch[i][2] - 11][0] === 0
              ) {
                countMustForP2 += 1;
                mustEat = true;
                squareRef.current[pawnsInTouch[i][0]].classList.add(
                  "box-waiting-for-selection"
                );
                squareRef.current[pawnsInTouch[i][1]].classList.add(
                  "box-waiting-for-selection"
                );
              } else if (playerTurn === 2) {
                if (pawnsInTouch[i][2] - 9 >= 1) {
                  if (boardData[pawnsInTouch[i][2] - 9][0] === 0) {
                    countMustForP2 += 1;
                    tempPrevousPawnP2 = minValue;
                    mustEat = true;
                    squareRef.current[minValue].classList.add(
                      "box-waiting-for-selection"
                    );
                  }
                }
                if (pawnsInTouch[i][2] - 11 >= 1) {
                  if (boardData[pawnsInTouch[i][2] - 11][0] === 0) {
                    countMustForP2 += 1;
                    tempPrevousPawnP2 = maxValue;
                    mustEat = true;
                    squareRef.current[maxValue].classList.add(
                      "box-waiting-for-selection"
                    );
                  }
                }
              }
            }
          }
        } else if (pawnsInTouch[i].length === 2) {
          const minValue = Math.min(...pawnsInTouch[i]);
          const maxValue = Math.max(...pawnsInTouch[i]);
          if (
            minValue + (minValue - maxValue) >= 1 &&
            minValue + (minValue - maxValue) <= 98
          ) {
            if (
              playerTurn === 2 &&
              boardData[minValue + (minValue - maxValue)][0] === 0
            ) {
              countMustForP2 += 1;
              tempPrevousPawnP2 = maxValue;
              mustEat = true;
              squareRef.current[maxValue].classList.add(
                "box-waiting-for-selection"
              );
            }
          }
          if (
            maxValue + (maxValue - minValue) >= 1 &&
            maxValue + (maxValue - minValue) <= 98
          ) {
            if (
              playerTurn === 1 &&
              boardData[maxValue + (maxValue - minValue)][0] === 0
            ) {
              countMustForP1 += 1;
              tempPrevousPawnP1 = minValue;

              mustEat = true;
              squareRef.current[minValue].classList.add(
                "box-waiting-for-selection"
              );
            }
          }
        }
      }
    }
  }
  if (dhamaIndex.length !== 0) {
    var mustEatWhithDhama = false;
    var mustEatWhithDhamaArray = [];
    for (let i = 0; i < dhamaIndex.length; i++) {
      if (
        (dhamaIndex[i][0] === 31 && playerTurn === 1) ||
        (dhamaIndex[i][0] === 32 && playerTurn === 2)
      ) {
        const prevRow = Math.floor(dhamaIndex[i][1] / 10);
        const prevCol = dhamaIndex[i][1] % 10;
        var result = dhamaMovesInit(
          prevRow,
          prevCol,
          matrixOfPawns,
          boardData,
          dhamaIndex[i][1],
          playerTurn
        );
        if (result.pawnsToEat.length !== 0) {
          mustEatWhithDhama = true;
          mustEatWhithDhamaArray.push(dhamaIndex[i][1]);
          squareRef.current[dhamaIndex[i][1]].classList.add(
            "box-waiting-for-selection"
          );
        }
      }
    }
  }
  if (x !== 2) {
    if (
      (boardData[currentSquareIndex][0] === 1 && playerTurn === 1) ||
      (boardData[currentSquareIndex][0] === 2 && playerTurn === 2)
    ) {
      x = 1;
    }
    if (prevSquare !== null) {
      if (
        (boardData[currentSquareIndex][0] === 32 && playerTurn === 2) ||
        (boardData[currentSquareIndex][0] === 31 && playerTurn === 1) ||
        ((boardData[currentSquareIndex][0] === 1 ||
          boardData[currentSquareIndex][0] === 2 ||
          boardData[currentSquareIndex][0] === 0) &&
          boardData[prevSquareIndex][0] === 31 &&
          playerTurn === 1) ||
        ((boardData[currentSquareIndex][0] === 1 ||
          boardData[currentSquareIndex][0] === 2 ||
          boardData[currentSquareIndex][0] === 0) &&
          boardData[prevSquareIndex][0] === 32 &&
          playerTurn === 2)
      ) {
        x = 4;
      }
    }
    if (mustEat || mustEatWhithDhama) {
      x = 3;
    }
  }
  if (x === 1) {
    handleSquareClick(
      boardDataRef,
      i,
      j,
      squareRef,
      squareRefPawns,
      boardData,
      setBoardData,
      playerTurn,
      prevSquare,
      setPrevSquare,
      setPlayerTurn,
      x,
      dhamaIndex,
      pawnsInTouch,
      activeSound
    );
  } else if (x === 2) {
    x = handleSquareClickEatMore(
      i,
      j,
      squareRef,
      squareRefPawns,
      boardData,
      setBoardData,
      playerTurn,
      prevSquare,
      setPrevSquare,
      setPlayerTurn,
      boardDataRef,
      x,
      previouspawnMustEat,
      dhamaIndex,
      pawnsInTouch,
      activeSound
    );
  } else if (x === 3) {
    [x, pawnsInTouch] = handleMustEat(
      pawnsInTouch,
      x,
      i,
      j,
      squareRef,
      squareRefPawns,
      boardData,
      setBoardData,
      playerTurn,
      prevSquare,
      setPrevSquare,
      setPlayerTurn,
      boardDataRef,
      countMustForP1,
      countMustForP2,
      tempPrevousPawnP1,
      tempPrevousPawnP2,
      dhamaIndex,
      matrixOfPawns,
      mustEat,
      mustEatWhithDhama,
      mustEatWhithDhamaArray,
      finalAllWays,
      pawnsToEat,
      activeSound
    );
  } else if (x === 4) {
    handleDhamaMoves(
      boardDataRef,
      i,
      j,
      squareRef,
      squareRefPawns,
      boardData,
      setBoardData,
      playerTurn,
      prevSquare,
      setPrevSquare,
      setPlayerTurn,
      x,
      finalAllWays,
      matrixOfPawns,
      dhamaIndex,
      pawnsToEat,
      pawnsInTouch,
      undefined,
      false,
      activeSound,
      mustEatWhithDhamaArray
    );
  }
}

export default Board;
